import { render, staticRenderFns } from "./m-pageContainer.vue?vue&type=template&id=2e5756fa&"
import script from "./m-pageContainer.vue?vue&type=script&lang=ts&"
export * from "./m-pageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./m-pageContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports